<template>
	<div class="product-list">
		<div class="common-form">公众号回复设置</div>
		<div style="display: flex;align-items: center;margin-bottom: 100px;">
			<div style="display: flex;flex-direction: column;">
				<h2>关注回复：</h2>
				<el-input type="textarea" :autosize="{ minRows: 8, maxRows: 4}" style="width: 600px;margin-right: 20px;"
					placeholder="请输入关注回复内容" v-model="cont.default_text" />
			</div>
			<div style="display: flex;flex-direction: column;">
				<h2>默认回复：</h2>
				<el-input type="textarea" :autosize="{ minRows: 8, maxRows: 4}" style="width: 600px;"
					placeholder="请输入默认回复内容" v-model="cont.subscribe_text" />
			</div>
		</div>

		<div class="common-form">公众号回复列表</div>
		<!--添加产品-->
		<div class="common-level-rail" style="display:flex;">
			<el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加</el-button>
		</div>
		<!--内容-->
		<div class="product-content">
			<div class="table-wrap">
				<el-table size="small" :data="tableData" border style="width: 100%">
					<el-table-column prop="name" align="center" label="规则名称"></el-table-column>
					<el-table-column prop="keyword" align="center" label="关键词"></el-table-column>
					<el-table-column prop="matching_type" align="center" label="匹配方式">
						<template slot-scope="scope">
							<span>{{scope.row.matching_type==1?'全匹配':scope.row.matching_type==2?'模糊匹配':''}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="content" label="回复内容" align="center"></el-table-column>
					<el-table-column prop="sort" label="分类排序" align="center"></el-table-column>
					<el-table-column fixed="right" label="操作"  align="center" width="180">
						<template slot-scope="scope">
							<el-button @click="editClick(scope.row)" type="primary" size="small">编辑</el-button>
							<el-button @click="delClick(scope.row)" type="danger" size="small">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagination">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
				:current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
				:total="totalDataNumber"></el-pagination>
		</div>

		<!--提交-->
		<div class="common-button-wrapper"><el-button type="primary" @click="onSubmit">提交</el-button></div>

		<!--添加-->
		<Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>
		<!--修改-->
		<Edit v-if="open_edit" :open_edit="open_edit" :editform="categoryModel"
			@closeDialog="closeDialogFunc($event, 'edit')"></Edit>

	</div>
</template>

<script>
	import AppSettingApi from "@/api/appsetting.js";
	import Add from "./add.vue";
	import Edit from "./edit.vue";
	export default {
		components: {
			Add,
			Edit
		},
		data() {
			return {
				status: "", //是否显示
				tableData: [],
				open_add: false,
				/*一页多少条*/
				pageSize: 20,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,
				searchForm: {
					sence_name: ""
				},
				open_add: false,
				open_edit: false,
				/*当前编辑的对象*/
				categoryModel: {},
				cont: {
					default_text: '',
					subscribe_text: ''
				}
			};
		},
		created() {
			/*获取列表*/
			this.getData();
		},
		methods: {
			//提交表单
			onSubmit() {
				let self = this;
				let params = self.cont;
				AppSettingApi.replyDefault(params, true)
					.then(data => {
						self.$message({
							message: '恭喜你，设置成功',
							type: 'success'
						});
					})
					.catch(error => {});
			},
			/*关闭弹窗*/
			closeDialogFunc(e, f) {
				if (f == "add") {
					this.open_add = e.openDialog;
					if (e.type == "success") {
						this.getData();
					}
				}
				if (f == "edit") {
					this.open_edit = e.openDialog;
					if (e.type == "success") {
						this.getData();
					}
				}
			},
			/*选择第几页*/
			handleCurrentChange(val) {
				let self = this;
				self.loading = true;
				self.curPage = val;
				self.getData();
			},
			/*每页多少条*/
			handleSizeChange(val) {
				this.pageSize = val;
				this.getData();
			},
			/*打开添加*/
			addClick() {
				this.open_add = true
			},
			// 详情
			getData() {
				let self = this;
				let Params = self.searchForm;
				Params.pageIndex = self.curPage;
				Params.pageSize = self.pageSize;
				AppSettingApi.replyList(Params, true)
					.then(data => {
						self.cont = data.data.data
						self.tableData = data.data.lists.data;
						self.totalDataNumber = data.data.lists.total;
					})
					.catch(error => {
						// self.loading = false;
					});
			},
			/*打开编辑*/
			editClick(row) {
				this.categoryModel = row
				this.open_edit = true
			},
			/*删除*/
			delClick: function(row) {
				let self = this;
				self
					.$confirm("确定删除该记录吗?", "提示", {
						type: "warning"
					})
					.then(() => {
						AppSettingApi.replyDel({
							reply_id: row.reply_id
						}).then(data => {
							self.$message({
								message: "删除成功",
								type: "success"
							});
							self.getData();
						});
					});
			}
		}
	};
</script>

<style scoped lang='scss'>
	.s_flex {
		display: flex;
		justify-content: space-between;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/views/appsetting/official/index.vue